module.exports = __webpack_public_path__ + "assets/img/logo_normal.ed4b79b0.png";